import React from 'react';

// this is the equivalent to the createStore method of Redux
// https://redux.js.org/api/createstore

const UserContext = React.createContext('Profile');

export default UserContext;
